import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild, DOCUMENT, inject } from '@angular/core';
import { Filters, IFilter } from '../../_shared/models/filters.model';
import { IconComponent } from '../../icon/icon.component';
import { BadgeComponent } from '../../badge/badge.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../button/button.component';
@Component({
    selector: 'sirius-filter-mobile',
    templateUrl: './filter-mobile.component.html',
    styleUrls: ['./filter-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, BadgeComponent, CommonModule, TranslateModule, ButtonComponent]
})
export class FilterMobileComponent implements AfterViewInit {
    private _document = inject<Document>(DOCUMENT);
    private _renderer = inject(Renderer2);

    @Input() filters: IFilter[] = [];

    @Output() menuClose = new EventEmitter<void>();
    @Output() selectionChange = new EventEmitter<Filters>();

    @ViewChild('container', { read: ElementRef }) container!: ElementRef;

    activeSubItems: boolean[] = [];
    selectedItem: IFilter = {
        id: '',
        name: '',
        activeCount: 0,
        values: [],
    };
    selectedItemIndex = 0;
    level = 0;
    hasChanges = false;

    ngAfterViewInit() {
        this.container.nativeElement.focus();
        this._renderer.setStyle(this._document.body, 'overflow-y', 'hidden');
    }

    previous() {
        this.level = 0;
        this.fillItems();
    }

    next(item: IFilter, index: number) {
        this.level += 1;
        this.selectedItemIndex = index;
        this.selectedItem = item;

        for (let i = 0; i < this.selectedItem.values.length; i++) {
            this.activeSubItems[i] = this.selectedItem.values[i].active;
        }
    }

    onBlur(event: FocusEvent) {
        const relatedTarget = event.relatedTarget as HTMLElement;

        if (!this.container.nativeElement.contains(relatedTarget)) {
            this.closeMenu();
        }
    }

    closeMenu() {
        this.saveSelection();
        this._renderer.setStyle(this._document.body, 'overflow-y', 'auto');
        this.menuClose.emit();
    }

    fillItems() {
        const filter = this.filters[this.selectedItemIndex];

        for (let i = 0; i < filter.values.length; i++) {
            if (filter.values[i].active === this.activeSubItems[i]) continue;

            if (!this.hasChanges) this.hasChanges = true;

            filter.values[i].active = this.activeSubItems[i];
        }

        const active = this.activeSubItems.filter((x) => x === true);
        filter.activeCount = active.length;
    }

    saveSelection() {
        if (this.level) this.fillItems();
        if (this.hasChanges) this.selectionChange.emit(new Filters(this.filters));
    }

    toggleActive(index: number) {
        this.activeSubItems[index] = !this.isActive(index);
    }

    isActive(index: number): boolean {
        return this.activeSubItems[index] === true;
    }

    clearCategories(): void {
        this.filters.forEach((x) => {
            x.activeCount = 0;
            x.values.forEach((y) => {
                y.active = false;
            });
        });
        this.fillItems();
    }

    clearSubItems(): void {
        for (let i = 0; i < this.activeSubItems.length; i++) {
            this.activeSubItems[i] = false;
        }
    }
}
